<template>
  <div class="my_form">
    <el-dialog
      title="重命名"
      :visible.sync="visible"
      width="500px"
      top='25vh'
      :before-close="onClose"
    >
      <el-form :model="form" ref="form" inline label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="新名称:" prop="name">
              <el-input v-model="form.name"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
       <el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import {CloudDisk} from "@/api/knowledge";

export default {
  name: "Rename",
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      form: {
        name: ''
      },
    }
  },
  methods: {
    handleSubmit() {
      if (this.form.name == '') {
        this.$message.error('请填写新名称');
      } else {
        CloudDisk.updateFile(this, {cloudDiskDto: {...this.record, name: this.form.name}}).then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.$emit('submitForm');
            this.onClose()
          }
        })
      }
    },
    onClose() {
      this.$emit('update:visible', false);
      this.form.name = ''
    },
  }
}
</script>

<style scoped lang="scss">
</style>
